'use strict';

wbApp.factory('semesterSvc', ['$resource', '$q', 'localStorageService', 'repositorySvc',
    function ($resource, $q, localStorageService, repositorySvc) {

        var Semester = $resource('/Api/Semesters/Get/:id', { openForRegistrationOnly: false }, {
            'courseSummary': { method: 'GET', isArray: false, url: '/Api/Semesters/GetCourseSummary', params: {} },
            'insert': { method: 'POST', url: '/Api/Semesters/Insert' },
            'update': { method: 'POST', url: '/Api/Semesters/Update' },
            'delete': { method: 'POST', url: '/Api/Semesters/Delete' }
        });

        var semesters = null;

        function newModel() {
            let semester = new Semester();
            semester.active = true;
            semester.showInCourses = true;
            semester.showInKindergarten = true;
            semester.isMain = false;
            return semester;
        }

        function sortSemestersIsMainFirst(semesters) {
            return _.orderBy(semesters, function (n) {
                if (n.active) {
                    return new Date(1970, 0, 1);
                }
                return n.startDate;
            }, false);
        }
 
        function getAllAsync(refresh) {
            if (!semesters || refresh) {
                semesters = repositorySvc.get(Semester, {});
            }
            return semesters;
        }

        function getAllActiveAsync() {
            let result = [];

            result.$promise = $q(function (resolve, reject) {
                let all = getAllAsync();

                all.$promise.then(function () {
                    result.push.apply(result,
                        _.filter(all, 'active'));
                    resolve(result);
                }, reject);
            });

            return result;
        }

        function getAllOpenForRegistrationAsync() {
            var result = [];

            result.$promise = $q(function (resolve, reject) {
                var all = getAllAsync();

                all.$promise.then(function () {
                    result.push.apply(result,
                        sortSemestersIsMainFirst(_.filter(all, function(s) {
                            return (s.openForRegistration || s.preferredBookingEffectiveIsActive) && s.showInCourses;
                        })));
                    resolve(result);
                }, reject);
            });

            return result;
        }

        function getAllShowInAttendanceAsync() {
            var result = [];

            result.$promise = $q(function (resolve, reject) {
                var all = getAllAsync();

                all.$promise.then(function () {
                    result.push.apply(result,
                        sortSemestersIsMainFirst(_.filter(all, { showInAttendance: true, showInCourses: true })));
                    resolve(result);
                }, reject);
            });

            return result;
        }

        function setDefault(semesterID) {
            if (localStorageService.isSupported && !!semesterID) {
                localStorageService.set('defaultSemesterID', semesterID);
            }
        }

        function getDefaultAsync() {
            var sem = getAllAsync();
            var deferred = $q.defer();

            var defaultSemesterID = null;
            
            if(localStorageService.isSupported) {
                defaultSemesterID = localStorageService.get('defaultSemesterID');
            }

            sem.$promise.then(function () {
                for (var i = 0; i < sem.length; i++) {
                    var s = sem[i];
                    if (!!defaultSemesterID) {
                        if (s.id == defaultSemesterID) {
                            deferred.resolve(sem[i]);
                            return;
                        }
                    } else if (s.active) {
                        deferred.resolve(sem[i]);
                        return;
                    }
                }

                if (sem.length > 0) {
                    deferred.resolve(sem[0]);
                    return;
                }

                deferred.resolve(null);
            });

            return deferred.promise;
        }

        function getActiveAsync() {
            var sem = getAllAsync();

            var deferred = $q.defer();

            sem.$promise.then(function () {
                for (var i = 0; i < sem.length; i++) {
                    var s = sem[i];
                    if (s.active) {
                        deferred.resolve(sem[i]);
                        return;
                    }
                }

                if (sem.length > 0) {
                    deferred.resolve(sem[0]);
                    return;
                }

                deferred.resolve(null);
            });

            return deferred.promise;
        }


        function get(id) {
            if (semesters) {
                for (var i = 0; i < semesters.length; i++) {
                    var sc = semesters[i];
                    if (sc.id == id) {
                        return sc;
                    }
                }
            }
            return null;
        }

        function getAsync(id) {
            var deferred = $q.defer();

            getAllAsync().$promise.then(function (sem) {
                angular.forEach(sem, function (value, key) {
                    if (value.id == id) {
                        deferred.resolve(value);
                        return;
                    }
                })
                deferred.resolve(null);
            }, function (errorResult) {
                deferred.reject(errorResult);
            });

            return deferred.promise;
        }

        function getCourseSummaryAsync(id) {
            return Semester.courseSummary({ semesterID: id });
        }

        function insert(data, successCallback, errorCallback) {
            return repositorySvc.insert(
                Semester,             // $resource
                semesters,            // collection
                data,                 // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback) {
            return repositorySvc.update(
                Semester,            // $resource
                semesters,           // collection
                data,                // entity
                successCallback,
                errorCallback,
                'id');
        }

        function remove(data, errorCallback) {
            return repositorySvc.remove(
                Semester,             // $resource
                semesters,            // collection
                data,                 // entity
                null,                 // successCallback
                errorCallback,
                null,
                'id');
        }


        return {
            newModel: newModel,
            getAllAsync: getAllAsync,
            getActiveAsync: getActiveAsync,
            get: get,
            getAsync: getAsync,
            getCourseSummaryAsync: getCourseSummaryAsync,
            getDefaultAsync: getDefaultAsync,
            setDefault: setDefault,
            getAllOpenForRegistrationAsync: getAllOpenForRegistrationAsync,
            getAllShowInAttendanceAsync: getAllShowInAttendanceAsync,
            insert: insert,
            update: update,
            remove: remove,
            getAllActiveAsync: getAllActiveAsync
        }

    }]);